module.exports = __webpack_public_path__ + "static/media/main idea.8ec5b022.mp3";